import React from "react";
import Parser from "html-react-parser";
import LazyImage from "./Lazyloader";
import {Link} from "react-router-dom";

const RelatedPosts = ({ relatedPosts }) => {
    if (!relatedPosts || relatedPosts.length === 0) {
        return null;
    }

    return (
        <section className="news-section-two layout-pt-20 style-one blog-externe layout-pt-60">
            <div className="auto-container">
                <div className="sec-title text-center">
                    <h2>Ces articles pourraient vous intéresser !</h2>
                </div>
                <div className="row justify-content-center">
                    {relatedPosts.map((post) => (
                        <div className={`blog-block col-lg-4 col-md-6 col-sm-12`}
                             style={{ padding: "0px 15px 20px 0" }}>
                            <div key={post.id}
                                 className="post-card">
                                    <div className="image-box">
                                        <Link to={`/blog/${post.slug}`} title={Parser(post.title)}>
                                            <figure className="image">
                                                <ul className="card-category-list">
                                                    {post.categories.map((cat, index) => (
                                                        <li key={index} className="privacy">{cat.name}</li>
                                                    ))}
                                                </ul>
                                                <LazyImage src={post.image}
                                                           alt={post.title}
                                                           width="100%" height="auto"/>
                                            </figure>
                                        </Link>
                                    </div>
                                    <div className="lower-content">
                                        <ul className="post-meta">
                                            <li><b>Par {post.author}</b> | le {post.date}</li>
                                        </ul>
                                        <Link to={`/blog/${post.slug}`}
                                              className="titleForum"
                                              title={Parser(post.title)}>{Parser(post.title)}</Link>
                                    </div>
                                </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default RelatedPosts;
